import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import classNames from "classnames";
import { FaLock } from "react-icons/fa";
import Swal from "sweetalert2";
import styled from 'styled-components';


const ChangepasswordContainer = styled.div`
  flex: 6;
  margin-top: 5px;
`;

const Changepassword = () => {
    const [submit, setSubmit] = useState("Submit");
    const [Username, setUsername] = useState("");



    useEffect(() => {
        const storedUsername = localStorage.getItem("Username");
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        getValues,
    } = useForm();

    const onSubmit = (data) => {
        const { oldPassword, newPassword } = getValues();
        // Include the values of these fields in the form data

        data.Old_Password = oldPassword;
        data.New_Password = newPassword;
        data.Username = Username;

        axios({
            method: "post",
            url: "http://localhost:82/Bmu_backend/teacherchangepassword.php",
            data: data,
            config: { headers: { "Content-Type": "multipart/form-data" } },
        })
            .then(function (response) {
                if (response.data.message === "Invalid old password.") {
                    Swal.fire(response.data.message, "", "error");
                } else {
                    Swal.fire(response.data.message, "", "success");
                }
                setSubmit("Submit");
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
        reset();
    };

    return (
        <>
            <ChangepasswordContainer>
                <div className="main-content">
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        autoComplete="off"
                        className="shadow-lg p-5 rounded-3"
                        style={{ marginTop: "100px", width: "75%", marginLeft: "auto", marginRight: "auto", maxWidth: "600px" }}

                    >
                        <div className="d-flex ">
                            <FaLock className=" me-2 " />
                            <p className="mb-0" style={{ fontWeight: "500" }}>
                                Change Password
                            </p>
                        </div>
                        <hr className="mb-3 mt-1" />
                        <div className="row jumbotron">
                            <div className="col-sm-12 mb-2 form-group">
                                <label className="form-label" htmlFor="name-f">
                                    Old Password
                                </label>
                                <input
                                    type="password"
                                    className={classNames("form-control shadow-sm", {
                                        "is-invalid": errors.oldPassword,
                                    })}
                                    placeholder="old  Password"
                                    {...register("oldPassword", {
                                        required: true,
                                    })}
                                />
                                {errors?.oldPassword?.type === "required" && (
                                    <p className="text-danger">Old Password is required !</p>
                                )}
                            </div>

                            <div className="col-sm-12 mb-2 form-group">
                                <label className="form-label" htmlFor="name-f">
                                    New Password
                                </label>
                                <input
                                    type="password"
                                    className={classNames("form-control shadow-sm", {
                                        "is-invalid": errors.newPassword,
                                    })}
                                    placeholder="New Password"
                                    {...register("newPassword", {
                                        required: true,
                                    })}
                                />
                                {errors?.newPassword?.type === "required" && (
                                    <p className="text-danger">New Password is required !</p>
                                )}

                            </div>

                            <div className="row mt-3">
                                <div className="col-sm-12 d-flex justify-content-center align-items-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                    >
                                        {submit}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ChangepasswordContainer>

        </>
    )
}

export default Changepassword
